import React from 'react';
import clsx from 'clsx';
import Grid from '@material-ui/core/Grid';
import Box from '@material-ui/core/Box';
import RegistrationFormProps from '../registration.types';
import { BUSINESS_REGISTRATION_TYPE } from '../registration.rules';
import Typography from '@material-ui/core/Typography';
import { createStyles, makeStyles } from '@material-ui/styles';
import colors from '../../../themes/main-colors';
import { BusinessIcon } from '../AccountTypeToggle/BusinessIcon';
import PersonOutlineOutlinedIcon from '@material-ui/icons/PersonOutlineOutlined';
import { useTranslation } from '../../../hooks/useTranslation';

const useStyles = makeStyles(() =>
  createStyles({
    applyingForBox: {
      border: `1px solid ${colors.lightGray}`,
      backgroundColor: colors.white,
      borderRadius: '0px',
      textAlign: 'center',
      fontSize: '0.875rem',
      cursor: 'pointer',
      fontFamily: 'Untitled-Sans',
      transition: 'all 0.2s',
      flex: 1,
      display: 'flex',
      alignItems: 'center',
      gap: 1,
      justifyContent: 'center',
      padding: '8px 12px',
      fontWeight: 600,
    },
    selectedApplyingForBox: {
      fontWeight: 600,
      color: colors.white,
      backgroundColor: colors.sparkBlue,
    },
  }),
);

interface BusinessRegistrationTypeToggleProps extends RegistrationFormProps {
  classes: any;
}

const BusinessRegistrationTypeToggle = (
  props: BusinessRegistrationTypeToggleProps,
) => {
  const classes = useStyles();
  const { form } = props;
  const { t } = useTranslation();

  return (
    <Box>
      <Grid>
        <Typography variant={'h2'}>
          {t('REGISTER_FOR_BUSINESS_TITLE')}
        </Typography>
        <Typography>{t('REGISTER_FOR_BUSINESS_DESC')}</Typography>
      </Grid>
      <Grid
        container
        direction="row"
        justify="space-between"
        css={{ margin: '16px 0 24px 0' }}
      >
        <Box
          className={clsx(
            classes.applyingForBox,
            form.values.businessRegistrationType ===
              BUSINESS_REGISTRATION_TYPE.BusinessEntity &&
              classes.selectedApplyingForBox,
          )}
          onClick={() =>
            form.setValue(
              'businessRegistrationType',
              BUSINESS_REGISTRATION_TYPE.BusinessEntity,
            )
          }
          data-testid="button-business-entity"
        >
          <BusinessIcon
            isSelected={
              form.values.businessRegistrationType ===
              BUSINESS_REGISTRATION_TYPE.BusinessEntity
            }
          />
          <span css={{ padding: '5px 0 0 8px' }}>{t('BUSINESS_ENTITY')}</span>
        </Box>
        <Box
          className={clsx(
            classes.applyingForBox,
            form.values.businessRegistrationType ===
              BUSINESS_REGISTRATION_TYPE.UserForBusiness &&
              classes.selectedApplyingForBox,
          )}
          onClick={() => {
            void form.setValue(
              'businessRegistrationType',
              BUSINESS_REGISTRATION_TYPE.UserForBusiness,
            );
          }}
          data-testid="button-user-for-business"
        >
          <PersonOutlineOutlinedIcon
            style={{
              color:
                form.values.businessRegistrationType ===
                BUSINESS_REGISTRATION_TYPE.UserForBusiness
                  ? colors.white
                  : colors.sparkBlue,
            }}
          />
          <span css={{ padding: '0 0 0 8px' }}>{t('USER_FOR_BUSINESS')}</span>
        </Box>
      </Grid>
    </Box>
  );
};

export default BusinessRegistrationTypeToggle;
